import {  Component, Input, OnInit, inject } from '@angular/core';
import { AuthLayoutComponent } from '../auth-layout/auth-layout';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-message-succes',
  standalone: true,
  imports: [AuthLayoutComponent],
  templateUrl: './message-succes.html',
  styleUrl: './message-succes.scss',
})
export class MessageSucces implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  @Input() menssage: string = '';

  protected title: string = '';
  protected message: string = '';
  protected buttonText: string = '';
  protected redirectTo: string = '';

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.title = params['title'] || '¡Listo!';
      this.message = params['message'] || '';
      this.buttonText = params['buttonText'] || 'Comenzar';
      this.redirectTo = params['redirectTo'] || 'login';

      if(this.redirectTo === 'new-password'){
        setTimeout(() => {
          this.redirectAutomatically()
        }, 2000);
      }
    });
  }

  onButtonClick() {
    if (this.redirectTo === 'new-password') {
      this.router.navigate(['/new-password']);
    } else {
      this.router.navigate(['/iniciar']);
    }
  }

  redirectAutomatically() {
    this.message = "Redirigiendo ..."
    setTimeout(() => {
      if (this.redirectTo === 'new-password') {
        this.router.navigate(['/new-password']);
      } 
    }, 3000);
  }
}